import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { IMyDpOptions } from 'mydatepicker';
import { AlertService } from '../../../providers/alert-service';
import { PessoalService } from '../../../providers/pessoal-service';
import { CargoService } from '../../../providers/cargo-service';
import { RolresponsaveisService } from '../../../providers/rolresponsaveis-service';


@Component({
    selector: 'page-modal-pessoal-termo-referencia',
    templateUrl: 'modal-pessoal-termo-referencia.html',
    providers: [
        AlertService,
        PessoalService
    ]
})
export class ModalPessoalTermoReferenciaPage {
    titulo: any;
    objeto: any;
    isCGE: any;
    listaCargo: any = [];
    listaDados: any = [];
    objetoRetorno: {
        flag: boolean,
        objeto: string
    };
    vinculoParaAdicionar: any = {
        "nomeCargo": "",
        "atividade": ""
    }

    private myDatePickerOptions: IMyDpOptions;

    analise: any = null;
    
    loading: boolean = false;

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        public rolService: RolresponsaveisService,
        public cargoService: CargoService,
        public alertService: AlertService,
        public alertCtrl: AlertController) {
        this.objetoRetorno = {
            flag: false,
            objeto: ""
        };

        this.titulo = this.navParams.get('param1');
        this.objeto = this.navParams.get('objeto');
        this.isCGE = this.navParams.get('isCGE');

        this.analise = this.navParams.get('analise');

        this.obterCargos();
    }

    obterCargos() {
        this.loading = true;
        this.cargoService.listarCargoAtivo(11).subscribe(data => {
            this.listaCargo = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    dismiss() {
        this.objetoRetorno.flag = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    mostrarAlerta(titulo, subtitulo) {
        let alert = this.alertCtrl.create({
            title: titulo,
            subTitle: subtitulo,
            buttons: ['Ok']
        });
        alert.present();
    }

    adicionar() {
        if (this.vinculoParaAdicionar.nomeCargo != '' &&
            this.vinculoParaAdicionar.atividade != '') {

            let vinculoNovo = {
                "idAtividadeTerceirizacao": 0,
                "dsAtividade": this.vinculoParaAdicionar.atividade,
                "cargo": {
                    "idCargo": 0,
                    "nomeCargo": this.vinculoParaAdicionar.nomeCargo
                },
                "idReferenciaContratosTerceirizacao": this.objeto.idReferenciaContratosTerceirizacao
            };

            let vinculoTemp = this.listaCargo.filter((cargo) => this.vinculoParaAdicionar.nomeCargo == cargo.nomeCargo)[0];

            if (vinculoTemp != null) {
                vinculoNovo.cargo.idCargo = vinculoTemp.idCargo;
            }

            if (this.objeto.atividadeTerceirizacoes.findIndex(i => i.cargo.nomeCargo === vinculoNovo.cargo.nomeCargo) != -1) {
                this.alertService.mostraAlerta("", "Vínculo já adicionado!");
            }
            else {

                this.objeto.atividadeTerceirizacoes.push(vinculoNovo);

                this.vinculoParaAdicionar.nomeCargo =
                    this.vinculoParaAdicionar.atividade = '';
            }
        }
    }

    remover(atividade) {
        if (atividade.idAtividadeTerceirizacao != "0") {
             this.pessoalService.deletarReferenciaContratosAtribuicao(atividade.idAtividadeTerceirizacao).subscribe(() => {
                 let index = this.objeto.atividadeTerceirizacoes.indexOf(atividade);
                 this.objeto.atividadeTerceirizacoes.splice(index, 1);
             }, error => {
                 this.mostrarAlerta("", "Ocorreu um erro ao deletar a atribuição: " + error.mensagem);
             });
        } else {
            let index = this.objeto.atividadeTerceirizacoes.indexOf(atividade);
            this.objeto.atividadeTerceirizacoes.splice(index, 1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pessoal-termo-referencia/modal-pessoal-termo-referencia.ts